import React from 'react';
import logo from 'assets/img/logo-desktop.svg';

const LogoBase = props => {
  return <img {...props} src={logo} alt="app-logo" />;
};

export default LogoBase;
